/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Na_StartedInputs */

const en_inbox_na_started = /** @type {(inputs: Inbox_Na_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Okay, the next step is being built.`)
};

const id_inbox_na_started = /** @type {(inputs: Inbox_Na_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oke, langkah berikutnya sedang dibangun.`)
};

/**
* | output |
* | --- |
* | "Okay, the next step is being built." |
*
* @param {Inbox_Na_StartedInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_started = /** @type {((inputs?: Inbox_Na_StartedInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_StartedInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_started(inputs)
	return en_inbox_na_started(inputs)
});